import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Formats a category name for display by removing the "Drawing " prefix.
 * Used in the front-end to show shorter category names while keeping
 * the full names in the back-end classifications.
 *
 * @example
 * formatCategoryDisplay("Drawing Detail") // returns "Detail"
 * formatCategoryDisplay("Drawing Plan") // returns "Plan"
 * formatCategoryDisplay("Design Brief") // returns "Design Brief" (unchanged)
 */
export function formatCategoryDisplay(categoryName: string): string {
  if (categoryName.startsWith("Drawing ")) {
    return categoryName.slice(8); // Remove "Drawing " (8 characters)
  }
  return categoryName;
}
